import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Unit } from '../../models/unit';
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from '@angular/forms';
import * as unitActions from '../../actions/unit';
import { Store } from '@ngrx/store';
import * as fromUnits from '../../reducers';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'mj-unit-info',
  templateUrl: 'unit-info.component.html',
  styleUrls: ['unit-info.component.scss'],
})
export class UnitInfoComponent implements OnChanges, OnDestroy, OnInit {
  @Input() unit: Unit;
  unitForm: FormGroup;
  formSub$: any;

  constructor(private fb: FormBuilder, private store: Store<fromUnits.State>) {
    this._initForm();
  }

  ngOnInit() {
    // this.unitForm
    //   .controls
    //   .description_rich
    //   .valueChanges.pipe(
    //     debounceTime(400),
    //     distinctUntilChanged()
    //   )
    //   .subscribe((data) => {
    //     const parsedData = JSON.parse(data);
    //     console.log(data);
    //     this.descCounter = (parsedData && parsedData.text) ? parsedData.text.length : 0;
    //   });
    // this.unitForm
    //   .controls
    //   .description_title_rich
    //   .valueChanges.pipe(
    //     debounceTime(400),
    //     distinctUntilChanged()
    //   )
    //   .subscribe((data) => {
    //     const parsedData = JSON.parse(data);
    //     console.log(data, this.editor2);
    //     this.titleCounter = (parsedData && parsedData.text) ? parsedData.text.length : 0;
    //   });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.unit && this.unit && this.unit.id) {
      this._fillForm(this.unit);
    }
  }

  private _initForm() {
    this.unitForm = this.fb.group(
      {
        id: ['', Validators.required],
        name: ['', Validators.required],
        parent_id: '',
        children: null,
        logo_media_id: null,
        logo_url: '',
        twitter_url: '',
        facebook_url: '',
        linkedin_url: '',
        website_url: '',
        description_title_rich: '',
        description_rich: '',
        description: '',
        description_image_url: '',
        description_image_media_id: null,
        address: '',
        lon: '',
        lat: '',
        same_as_parent_logo: true,
        same_as_parent_address: true,
        same_as_parent_facebook_url: true,
        same_as_parent_linkedin_url: true,
        same_as_parent_twitter_url: true,
        same_as_parent_website_url: true,
        same_as_parent_description: true,
      },
      { updateOn: 'blur' }
    );

    this._onChanges();
  }

  _onChanges() {
    this.formSub$ = this.unitForm.valueChanges
      .pipe(
        debounceTime(700),
        distinctUntilChanged(),
        map(unit => {
          if (this.unitForm.dirty) {
            this.updateAction(unit);
            this.unitForm.markAsPristine();
          }
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    if (this.formSub$) {
      this.formSub$.unsubscribe();
    }
  }

  private _fillForm(unit: Unit) {
    this.unitForm.patchValue({
      id: unit.id,
      name: unit.name,
      parent_id: unit.parent_id,
      children: unit.children,
      logo_media_id: unit.logo_media_id,
      logo_url: unit.logo_url,
      twitter_url: unit.twitter_url,
      facebook_url: unit.facebook_url,
      linkedin_url: unit.linkedin_url,
      website_url: unit.website_url,
      description_title_rich: unit.description_title_rich,
      description_rich: unit.description_rich,
      description: unit.description,
      description_image_url: unit.description_image_url,
      description_image_media_id: unit.description_image_media_id,
      address: unit.address,
      lon: unit.lon,
      lat: unit.lat,
      same_as_parent_logo: unit.same_as_parent_logo,
      same_as_parent_address: unit.same_as_parent_address,
      same_as_parent_facebook_url: unit.same_as_parent_facebook_url,
      same_as_parent_linkedin_url: unit.same_as_parent_linkedin_url,
      same_as_parent_website_url: unit.same_as_parent_website_url,
      same_as_parent_twitter_url: unit.same_as_parent_twitter_url,
      same_as_parent_description: unit.same_as_parent_description,
    });
  }

  public setAddress(e) {
    this.unitForm.patchValue({
      address: e.formatted_address,
      lon: e.geometry.location.lng(),
      lat: e.geometry.location.lat(),
    });
  }

  public updateAction(unit: Unit) {
    this.unitForm.patchValue(unit);
    this.store.dispatch(new unitActions.UpdateUnit({ unit: this.unitValue }));
  }

  public updateMirror($event: { field: string; value: boolean }) {
    this.unitForm.controls[$event.field].patchValue($event.value);
    this.updateAction(this.unitValue);
  }

  get unitValue() {
    return this.unitForm.value;
  }
}
